import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import XEUtils from 'xe-utils'
import './api'
import './packages/lq-ui'
import './lQGlobalApi'
import { getCustomizedConfigByKey } from "@/frontendCustomizedConfig/index.js"
import { getApiHost, getBaseUrl, getHeaderAuth, getHost, isFrame, getlqAssetsBaseUrl } from '@/utils/common'
import { formatApi } from '@/api/ref'
import '@/utils/pageAjax'
import strrole from '@/utils/strrole'
import LQProgress from '@/components/LQProgress'
import { checkReuseResource } from './loadSource'
// 引入element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 全局引入overlay 全局蒙层
import OverlayPlugin from '@/components/GlobalOverlay/overlay.js'
// 全局引入element-ui
Vue.use(ElementUI)
Vue.use(LQProgress)
// 全局引入overlay 全局蒙层
Vue.use(OverlayPlugin)

Vue.prototype.getCustomizedConfigByKey = getCustomizedConfigByKey
// 全局指令
import '@/utils/commonDirective.js'

// 添加自定义弹框
import '@/utils/extendElementUI.js'

import { VERSION_TYPES } from '@/constants/index'
window.__version_type = VERSION_TYPES
window.__lq_isFrame = isFrame
window.__lq_host = getHost()
window.__lq_api_host = getApiHost()
window.__lq_format_api = formatApi
window.__lq_auth = getHeaderAuth()
window.__lq_base_url = getBaseUrl()
window.__lq_assets_base_url = getlqAssetsBaseUrl()
window.gr_InstallPath = window.__lq_assets_base_url + '/tools'
window.getCustomizedConfigByKey = getCustomizedConfigByKey
window._AMapSecurityConfig = {
  securityJsCode: 'f46da87ef0a033538042855c41cfbbdf'
}
if (!(top as any).PARAPAGESIZE) {
  ;(top as any).PARAPAGESIZE = 5000
}
if (!(top as any).MAXREQUESTNUN) {
  ;(top as any).MAXREQUESTNUN = 6
}
Vue.config.productionTip = false
if (!(top as any).pathStrrole) {
  ;(top as any).pathStrrole = {} // .net页面写死的权限码
  for (let key of Object.keys(strrole)) {
    ;(top as any).pathStrrole[key.toLowerCase()] = strrole[key]
  }
  // 注意：strrole.ts文件里面调用的window，是指向生成top.pathStrrole的页面的window
  // 也就是说，例如location相关的全局变量，取的是生成top.pathStrrole的页面的window.location
  // 所以，strrole.ts文件里面，要慎用window.x变量，除非调用的window.x，其它页面返回值也是一样的，才可使用
}

import ImgWebp from '@/components/imgWebp/index.vue'
Vue.component('ImgWebp', ImgWebp)

checkReuseResource(startMount)
// startMount()

function startMount() {
  // 校验新老首页，不可通过手动修改url切换
  if (top == self) {
    // 应该是新版本，但是访问旧首页url，跳转新版本
    if (location.pathname.includes('/home/index') && top.$ && top.$.cookie("HOMEPAGE_VERSION") == "V2") {
      location.replace(window.location.href.replace('/home/index', '/homeV2/index'))
      return
    }
    // 应该是旧版本，但是访问新首页url，跳转旧版本
    if (location.pathname.includes('/homeV2/index') && top.$ && top.$.cookie("HOMEPAGE_VERSION") != "V2") {
      location.replace(window.location.href.replace('/homeV2/index', '/home/index'))
      return
    }
  }
  const VM = new Vue({
    router,
    render: h => h(App)
  })
  VM.$mount('#app')
  window.VM = VM
}
